import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  TextField,
} from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { useUserDetails } from "../../../context/auth";
import Swal from "sweetalert2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import { error } from "pdf-lib";
function LeaveApproval() {
  const [employeeData, setemployeeData] = useState([]);
  console.log("employeeData:", employeeData);

  const [ID, setID] = useState("");

  const navigate = useNavigate();
  const { HRRoleLeave, ManagerLeave, AccessData, HRLIST } = useUserDetails();

  let Roledata = JSON.parse(sessionStorage.getItem("MainApp"));
  console.log("Roledata",Roledata);
  
  const locatdatas = JSON.parse(sessionStorage.getItem("user"));
  console.log("Roledata:", Roledata);
  const [Alldata, setAlldata] = useState("");

  const [display, setdisplay] = useState(false);
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setID(id);
    if (id) {
      getemployeedata(id);
    }
  }, []);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const getemployeedata = async (id) => {
    const query = ` query GetLeaveById($id: String!) {
 
  getLeaveById(id: $id) {
 
    data {
 
      id
 
      reason
 
      totalDays 
      user{
        id
        firstName
        lastName
      }
      status
      teamApproval
      hrApproval
      teamleaderId
         leaveFrom  
 
      leaveTill  
      leaveType{
        id
        name
      }

 
      primaryDor{
 
        firstName
        lastName
 
      }
 
 
      secondaryDor{
 
        firstName
        lastName
 
      } 
      attachment
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
      }
 
 
      followUpTasks
 
    }
 
    success
 
    error
 
    message
 
  }
 
}
  `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const leaveDatass = response.data.data.getLeaveById?.data[0];
      setAlldata(leaveDatass);
      console.log("leaveDatass:", leaveDatass);
      setemployeeData(leaveDatass);
      if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "ApplyLeave" &&
            item.component === "ManagerApproval" &&
            item.can_access
        )
      ) {
        console.log("Error1");

        if (leaveDatass.teamApproval == "Pending") {
          setdisplay(true);
          console.log("THIEUEHD");
        } else {
          setdisplay(false);
        }
      } else if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "ApplyLeave" &&
            item.component === "HrApproval" &&
            item.can_access
        )
      ) 
      console.log("innnnnn");
      {
        if (Roledata == "HRList") {
          console.log("innnnnnn");
          
          if (leaveDatass.teamApproval == "Pending") {
            setdisplay(true);
            console.log("THIEUEHD");
          }
        } else if (Roledata == "HR") {
          console.log("innnnn");
          
          if (
            leaveDatass.teamApproval == "approved" &&
            leaveDatass.hrApproval == "pending"
          ) {
            setdisplay(true);
          }
        }
      }

      // if (leaveDatass.teamApproval == "approved") {
      //   console.log('Error2')
      //   setdisplay(true);
      // } else if (leaveDatass.teamApproval == "rejected") {
      //   setdisplay(false);
      // }
    } catch (error) {
      console.log("ReponseError:", error);
    }
  };

  const handleAddLeave = (statusdata) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: `Are you sure you want to ${
        statusdata == "approved"
          ? "Approve"
          : statusdata == "rejected"
          ? "Reject"
          : ""
      } the leave?`,
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ApproveSubmit(statusdata);
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ApproveSubmit = async (statusdata) => {
    let query;
    let variables;
    //     if (
    //       AccessData &&
    //       Array.isArray(AccessData) &&
    //       AccessData.some(
    //         (item) => item.component === "HrApproval" && item.can_access
    //       )
    //     ) {
    //       if (Roledata == "HRList") {
    //         if (Alldata.teamApproval == "Pending") {
    //           console.log("jnjncndbbdcc");

    //           query = `
    //           mutation leaveManagerApproval($id: String!, $status: String!) {
    //             leaveapprovalmanager(id: $id, status: $status) {
    //               leaveApprovalManager {
    //                 id
    //                 requestedOn
    //                 leaveType {
    //                   leaveType
    //                 }
    //                 leaveFrom
    //                 leaveTill
    //                 totalDays
    //                 halfDay
    //                 reason
    //                 status
    //                 hrApproval
    //                 teamleaderId
    //                 teamApproval
    //               }
    //             }
    //           }
    //         `;
    //         }
    //       } else if (
    //         Roledata == "HR" &&
    //         Alldata.teamApproval == "approved" &&
    //         Alldata.hrApproval == "Pending"
    //       ) {
    //         query = `
    //         mutation leaveHrApproval($id: String!, $status: String!) {
    //   leaveapprovalhr(id: $id, status: $status) {
    //     leaveApprovalHR {
    //       id
    //       requestedOn
    //       leaveType{
    //         leaveType
    //       }
    //       leaveFrom
    //       leaveTill
    //       totalDays
    //       halfDay
    //       reason
    //       status
    //       teamleaderId
    //       teamApproval
    //       hrApproval
    //     }
    //   }
    // }
    //       `;
    //       }
    //     } else {
    //       query = `
    //          mutation leaveManagerApproval($id:String! $status:String! $approver_id:ID!){

    //   leaveapprovalmanager(id:$id status:$status approverId: $approver_id){

    //     leaveApprovalManager{

    //       id

    //       requestedOn

    //       leaveType {

    //         id

    //         leaveType

    //       }

    //       leaveFrom

    //       leaveTill

    //       totalDays

    //       halfDay

    //       reason

    //       status

    //       teamleaderId

    //       teamApproval

    //     }

    //   }

    // }
    //         `;
    //     }
    if (employeeData?.approvalStatus !== null) {
      query = `
   mutation leaveManagerApproval($id:String! $status:String! $approver_id:ID! $screen_name: String!){  
 
  leaveapprovalmanager(id:$id status:$status approverId: $approver_id screenName: $screen_name){  
 
    leaveApprovalManager{  
 
      id  
 
      requestedOn  
 
      leaveType {
 
        id
 
        name
 
      }
 
      leaveFrom  
 
      leaveTill  
 
      totalDays  
 
      halfDay  
 
      reason  
 
      status  
 
      teamleaderId  
 
      teamApproval  
      hrApproval
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
      }
 
    }  
 
  }  
 
}
  `;

      variables = {
        id: +ID,
        status: statusdata,
        approver_id: locatdatas?.id,
        screen_name: "Leave Approval",
      };
    } else {
      // HR approval
      query = `
   mutation leaveHrApproval($id:String! $status:String!){  
 
  leaveapprovalhr(id:$id status:$status){  
 
    leaveApprovalHR{  
 
      id  
 
      requestedOn  
 
      leaveType {
 
        id
 
        name
 
      }
 
      leaveFrom  
 
      leaveTill  
 
      totalDays  
 
      halfDay  
 
      reason  
 
      status  
 
      teamleaderId  
 
      teamApproval  
      hrApproval
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
      }
 
    }  
 
  }  
 
} 
  `;

      variables = {
        id: +ID,
        status: statusdata,
      };
    }

    try {
      const response = await axios.post(
        BASEURL, // Replace with your actual GraphQL endpoint
        {
          query: query,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responseHR:", response.data);

      // console.log(
      //   "Response:",
      //   response.data.data.regularizationApproval.regularizationApprovalHR
      // );

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (response.data.data?.leaveapprovalhr?.leaveApprovalHR) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/appyleave");
      } 
      else if(response.data?.errors){
        const message = response.data?.errors.errors[0].message
        console.log(message,"msgg");
        
         Swal.fire({
          position: "center",
          icon: "error",
          title:message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
      else if (
        response.data.data?.leaveapprovalmanager?.leaveApprovalManager
      ) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `${
            statusdata.charAt(0).toUpperCase() + statusdata.slice(1)
          } successfully!`,
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/appyleave");
      }
      // Handle success (e.g., show a success message or navigate)
    } catch (error) {
      console.error("Error in ApproveSubmit:", error);
      // Handle error (e.g., show a user-friendly error message)
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // This will return 'dd/mm/yyyy' format
  }

  const handleclose = () => {
    navigate("/appyleave");
  };

  const getFormattedLeaveType = (leaveType) => {
    return leaveType
      ?.replace(/_/g, " ")
      ?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 2, boxShadow: 3 }}>
        <CardHeader
          title={
            <Stack direction="column" spacing={0}>
              <Typography variant="h5" fontWeight="bold" textAlign="center">
                Leave Details
              </Typography>
            </Stack>
          }
        />
        <CardContent>
          <Grid container spacing={1} marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.user?.firstName?.toUpperCase()}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Leave Type:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {getFormattedLeaveType(employeeData.leaveType?.name)}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Leave From:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.leaveFrom}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Leave Till:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.leaveTill}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Total Days:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.totalDays}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.reason}
                  </span>
                </Typography>
                
                <Typography variant="h6">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.status == "approved"
                      ? "Approved"
                      : employeeData?.status == "rejected"
                      ? "Rejected"
                      : employeeData?.status}
                  </span>
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          {/* Close and Action Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            {(employeeData?.approvalStatus?.approver?.id == locatdatas?.id ||
              display) && (
              <>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleAddLeave("approved")}
                  >
                    Approve
                  </MaterialButton>
                </Grid>
                <Grid item>
                  <MaterialButton
                    variant="contained"
                    color="secondary"
                    onClick={() => handleAddLeave("rejected")}
                  >
                    Reject
                  </MaterialButton>
                </Grid>
              </>
            )}
            <Grid item>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default LeaveApproval;
